import React from "react";
import { BlueBtn } from "../../../utils/utils";
import { NavLink } from "react-router-dom";

const About = () => {
  return (
    <div className="relative py-16 px-6 lg:px-24 overflow-hidden">
      {/* Background with lower opacity */}
      <div
        className="absolute inset-0 bg-no-repeat bg-cover bg-center opacity-10 z-0"
        style={{
          backgroundImage: `url(/assets/line_bg.webp)`,
        }}
      />

      <div className="relative z-10 flax flex-col-reverse lg:flex-row items-center justify-between gap-12">
        <div className="w-full lg:w-1/2">
          <img
            src={`/assets/new_2.webp`}
            alt="Production Process"
            className="w-full h-auto shadow-sharp-blue"
          />
        </div>
        {/* Left text content */}
        <div className="title-space text-left">
          <div className="section-title">Who We Are</div>
          <div className="text-3xl lg:text-4xl font-bold text-primary-200">
            The wrap that makes you love the product.
          </div>
          <div className="text-text_color-100 max-w-xl">
            We are a dedicated manufacturer of high-quality thermocol products,
            specializing in protective packaging, insulation, and custom-molded
            solutions. With a focus on innovation and precision, we craft
            thermocol components that ensure safety, stability, and performance
            across diverse industries — from electronics and pharma to
            construction and retail.
            <br />
            <br />
            Our commitment lies in sustainability, customer satisfaction, and
            engineering excellence. Whether it’s shock-absorbent packaging or
            soundproof sheets, we deliver tailored solutions that wrap your
            products with confidence.
          </div>
          <NavLink to="/">
            <BlueBtn children="Discover more" />
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default About;
